import axiosInstance from "./axiosInstance";

const createBooking = async (data) => {
  return await axiosInstance.post(
    //`${process.env.REACT_APP_RESERVATIO_URL}/create_booking`,
    `${process.env.REACT_APP_BASE_URL}/reservatio-crearBooking`,
    data,
    {
      // headers: {
      //   Token: process.env.REACT_APP_RESERVATIO_TOKEN,
      // },
      withCredentials: true,
    }
  );
};

export default createBooking;
